import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Popover } from '@material-ui/core';

const initialState = {
  mouseX: null,
  mouseY: null,
};

const styles = {
  tooltip: {
    pointerEvents: 'none',
  },
  tooltipContent: {
    padding: '5px',
  },
};

const Tooltip = ({ children, title }) => {
  const [state, setState] = useState(initialState);
  const [showTooltip, setShowTooltip] = useState(false);

  if (!title) {
    return children;
  }

  const handleMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  const handleMouseMovement = (event) => {
    setState({
      mouseX: event.clientX + 20,
      mouseY: event.clientY,
    });
  };

  return (
    <div>
      <div onMouseMove={handleMouseMovement} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        {children}
      </div>
      <Popover
        style={styles.tooltip}
        open={showTooltip && state.mouseY !== null}
        anchorReference="anchorPosition"
        anchorPosition={
          state.mouseY !== null && state.mouseX !== null
            ? { top: state.mouseY, left: state.mouseX }
            : undefined
        }
      >
        <div style={styles.tooltipContent}>
          {title}
        </div>
      </Popover>
    </div>
  );
};

Tooltip.propTypes = {
  children: PropTypes.any.isRequired,
  title: PropTypes.string,
};

Tooltip.defaultProps = {
  title: null,
};

export default Tooltip;
